import { create } from '@tiendanube/nexo';

/**
 * Single shared Nexo client. Nexo is the message bus between this iframe app and the
 * Nuvemshop admin (observer pattern). It is initialized with the app's client id; the
 * admin hands us the session token and store info over this channel.
 */
const nexo = create({
  clientId: import.meta.env.VITE_NUVEMSHOP_CLIENT_ID,
  log: import.meta.env.DEV,
});

export default nexo;
